module.exports = __webpack_public_path__ + "img/gift-voucher-icon.b6dbd198.svg";